import React from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom'

const Gracias = () => {
  return (
    <section>
      <div className='p-20 h-screen flex flex-col justify-center items-center gap-5'>
        <p className='text-6xl font-bold text-yellow-1 uppercase'>¡Gracias por contactarnos!</p>
        <p className='text-xl w-4/5 text-center'>Un asesor se pondrá en contacto contigo dentro de las próximas 48 horas hábiles. Si necesitas asistencia antes, llamanos a +57 318 316 3984 o a nuestra oficina 602 721 0751 en Pasto.</p>
        <Link to={"/"} className='px-4 py-2 bg-primario w-max text-secundario rounded-lg rounded-tl-none font-bold shadow-custom-second text-xl'>Volver al inicio</Link>
      </div>
    </section>
  )
}

export default Gracias